import { Injectable } from '@angular/core';
import { TasksApiService } from './tasks-api.service';

@Injectable({ providedIn: 'root' })
export class EmulatorTasksApiService extends TasksApiService {
  protected get baseUrl(): string {
    return super.baseUrl.replace('tasks', 'emulator-tasks');
  }
}
